import { render, staticRenderFns } from "./inventory-table-row.vue?vue&type=template&id=2bb64cde&scoped=true"
import script from "./inventory-table-row.vue?vue&type=script&lang=js"
export * from "./inventory-table-row.vue?vue&type=script&lang=js"
import style0 from "./inventory-table-row.vue?vue&type=style&index=0&id=2bb64cde&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb64cde",
  null
  
)

export default component.exports